import { render, staticRenderFns } from "./iconPersonCircle.vue?vue&type=template&id=625eb23d&scoped=true"
import script from "./iconPersonCircle.vue?vue&type=script&lang=js"
export * from "./iconPersonCircle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625eb23d",
  null
  
)

export default component.exports